import { TipTapBlockEditor } from "@circle-react-shared/uikit/TipTapBlockEditor";

interface DisplayTiptapContentProps {
  tiptapBody: any;
}

export const DisplayTiptapContent = ({
  tiptapBody,
}: DisplayTiptapContentProps) => (
  <TipTapBlockEditor
    readOnly
    value={tiptapBody.body}
    sgidToObjectMap={tiptapBody.sgids_to_object_map}
    inlineAttachments={tiptapBody.inline_attachments}
    openInternalLinksInCurrentTab
    disabledExtensions={["cta"]}
    shouldSupportTables
  />
);
